module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxMCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguMjYwMiA4LjI5OThMNC42OCAxMS41MTM4TDEuMDk5OCA4LjI5OThMMCA5LjI4OTI4TDQuNjggMTMuNDk5OEw5LjM2IDkuMjg5MjhMOC4yNjAyIDguMjk5OFoiIGZpbGw9IiM5NTk1OTUiLz4KPHBhdGggZD0iTTEuMDk5MTcgNS43MDAxOUw0LjY3OTM4IDIuNDg2MTZMOC4yNTk1OCA1LjcwMDJMOS4zNTkzOCA0LjcxMDcyTDQuNjc5MzggMC41MDAxOTZMLTAuMDAwNjI1NTEzIDQuNzEwNzJMMS4wOTkxNyA1LjcwMDE5WiIgZmlsbD0iIzk1OTU5NSIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/homebase/bookmarks/sorting-caret.svg
// module id = UJ1S
// module chunks = 1